import { Component, Input } from '@angular/core';

@Component({
  selector: 'skeleton',
  templateUrl: './skeleton.component.html'
})
export class SkeletonComponent {
  @Input() width = '100%';
  @Input() height = '1rem';
  @Input() rounded = 'rounded-lg';
  @Input() circle = false;
  @Input() background = 'bg-slate-200';
}
